const paperStyles = (theme) => ({
  [theme.breakpoints.up("md")]: {
    paddingY: " 20px",
  },
  width: "100%",
  marginX: "auto",
});

const paperOrganizationStyles = (theme) => ({
  background:"none",
  boxShadow:"none"
});

const buttonStyles = (theme) => ({
  m: 1,
  [theme.breakpoints.up("md")]: {
    marginBottom: "20px",
    marginX: "20px",
  },
  minWidth: "150px",
});

const tabStyles = (theme) => ({
  textTransform: "none !important",
  [theme.breakpoints.up("md")]: { alignSelf: "start" },
  minHeight: "50px",
});

export { paperStyles, buttonStyles, tabStyles,paperOrganizationStyles };
